<template>
    <tr
        :class="['parametric-row', {'is-booked': flat.isBooked}]"
        @click="redirectLeft(flat.link)"
        @click.right="redirectRight(flat.link)"
    >
        <td>
            <div @mouseenter="setPreviewPosition" @mouseleave="isBottom = false"
                 :class="['parametric-row__plan', {'parametric-row__plan_theme_up': isBottom}]">
                <div class="parametric-results__loader">
                    <img class="parametric-row__plan-img" :src="flat.plan" :alt="flat.title">
                </div>

                <div class="parametric-row__plan-big">
                    <img :src="flat.planBig" :alt="flat.title">
                </div>
            </div>
        </td>

        <td class="parametric-row__title-cell">
            <div class="parametric-row__title">
                <div class="parametric-results__loader">
                    {{ flat.title }}
                    <div v-if="!isEstateFlat && flat.building && flat.section" class="parametric-results__annotation">
                        Корпус {{ flat.building }}, секция {{ flat.section }}
                    </div>
                </div>
            </div>
            <ul v-if="visibleUtp" class="tags tags_theme_not-order">
                <li
                    v-for="option in visibleUtp"
                    :key="option.key"
                    :class="['tags__item', `tags__item_color_${option.color}`,
                        'tags__item_theme_flat', 'tags__item_theme_narrow', 'parametric-results__loader']"
                >
                    {{ option.name }}
                </li>
                <li v-if="hiddenUpt" class="tags__addition">
                    <span></span>
                    <ul class="tags__list-popup">
                        <li
                            v-for="option in hiddenUpt"
                            :key="option.key"
                        >
                            {{ option.name }}
                        </li>
                    </ul>
                </li>
            </ul>
        </td>

        <td>
            <div class="parametric-results__loader">{{ flat.area }}</div>
        </td>

        <td v-if="isEstateFlat">
            <div class="parametric-results__loader">
                {{ flat.floor }}
                <span class="parametric-row__floors">из {{ flat.floorsTotal }}</span>
            </div>
        </td>

        <td>
            <div class="parametric-results__loader">{{ flat.deadlineText }}</div>
        </td>

        <td class="parametric-row__price-cell">
            <ul v-if="!flat.isBooked" class="parametric-row__prices-list">
                <li class="parametric-row__prices-item parametric-results__loader">
                    {{ convertToDigit(flat.price) }}

                    <div v-if="flat.action" class="parametric-row__price-action action-label">
                        {{ flat.action.value }}
                        <div class="action-label__tooltip">
                            {{ flat.action.text }}
                        </div>
                    </div>
                </li>

                <li v-if="flat.priceOld" class="parametric-row__prices-item parametric-row__price-old
                    parametric-results__loader">
                    {{ convertToDigit(flat.priceOld) }}
                </li>
            </ul>

            <div v-if="flat.isBooked" class="parametric-row__reserved-text parametric-results__loader">
                Забронировано
            </div>
        </td>
    </tr>
</template>

<script>
import {convertToDigit} from '../../mixins.js';

export default {
    data() {
        return {
            isBottom: false
        };
    },

    props : ['flat', 'isEstateFlat'],
    mixins: [convertToDigit],

    computed: {
        visibleUtp() {
            if (!this.flat.options || !this.flat.options.length) {
                return false;
            }

            return this.flat.options.slice(0, 1);
        },

        hiddenUpt() {
            if (!this.flat.options || !this.flat.options.length) {
                return false;
            }

            return this.flat.options.slice(1).length ? this.flat.options.slice(1) : false;
        }
    },

    methods: {
        redirectRight(link) {
            window.open(link, '_blank');
        },

        redirectLeft(link) {
            window.location = link;
        },

        setPreviewPosition(event) {
            const browserHalfHeight = document.documentElement.clientHeight / 2;

            if (event.clientY > browserHalfHeight) {
                this.isBottom = true;
            }
        }
    }
};
</script>
